import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, DEFAULT_CURRENCY_CODE, LOCALE_ID, inject, provideAppInitializer } from '@angular/core';
import { provideRouter } from '@angular/router';
import { CrmAppConfig } from '@touch4it/ng-swp/core';
import { crmProvideEndpoint } from '@touch4it/ng-swp/endpoint';
import { crmProvideLayout } from '@touch4it/ng-swp/layout-v2';
import { crmProvideMessage } from '@touch4it/ng-swp/message';
import { crmProvideModal } from '@touch4it/ng-swp/modal';
import { crmProvideTranslate } from '@touch4it/ng-swp/translate';
import { en_US, NZ_DATE_CONFIG, NZ_I18N } from 'ng-zorro-antd/i18n';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { lastValueFrom, of, switchMap, tap } from 'rxjs';
import { provideNzDateFnsAdapter } from 'ng-zorro-antd/core/time';

import { AuthService } from '~/api/auth/auth.service';
import { authInterceptor } from '~/api/auth/auth.interceptor';
import { CurrenciesApiService } from '~/api/currencies/currencies-api.service';
import { setCurrencyRegistry } from '~/shared/utils/format/currency-registry';

import { routes } from './app.routes';
import { crmConfig } from './config/crm.config';
import { endpointConfig } from './config/endpoint.config';
import { layoutConfig } from './config/layout.config';
import { translateConfig } from './config/translate.config';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),

    { provide: NZ_I18N, useValue: en_US },
    { provide: NZ_DATE_CONFIG, useValue: { firstDayOfWeek: 1 } },

    { provide: CrmAppConfig, useValue: crmConfig },
    crmProvideLayout(layoutConfig),
    crmProvideTranslate(translateConfig),
    crmProvideEndpoint(endpointConfig),
    crmProvideModal(),
    crmProvideMessage(),

    provideAppInitializer(() => {
      const user = inject(AuthService);
      const currencies = inject(CurrenciesApiService);

      return lastValueFrom(
        user
          .checkAuth()
          .pipe(
            switchMap((isAuthenticated) =>
              isAuthenticated ? currencies.listAll().pipe(tap(setCurrencyRegistry)) : of(undefined),
            ),
          ),
        { defaultValue: undefined },
      ).catch((error) => {
        console.error('Failed to load currencies', error);
      });
    }),

    { provide: LOCALE_ID, useValue: 'sk' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR' },
    provideEnvironmentNgxMask(),
    provideNzDateFnsAdapter(),
  ],
};
